import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DevelopmentChargesModel } from "services/api/cplapi/CPLAPI";
import { IServiceChargeInvoicingService } from "services/ServiceChargeInvoicingService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

type DevelopmentChargesPreListProps = {
  RunDevelopmentChargesCalculation: boolean;
  GeneratingDevelopmentChargesPreList: boolean;
  DevelopmentCharges: DevelopmentChargesModel[];
};

const initialState: DevelopmentChargesPreListProps = {
  RunDevelopmentChargesCalculation: false,
  GeneratingDevelopmentChargesPreList: false,
  DevelopmentCharges: new Array<DevelopmentChargesModel>(),
};

export const DevelopmentChargesPreListSlice = createSlice({
  name: "developmentChargesPreList",
  initialState,
  reducers: {
    setRunPreListCalculation: (state, action) => {
      state.RunDevelopmentChargesCalculation = action.payload;
    },
    setGeneratingDevelopmentChargesPreList: (state, action) => {
      state.GeneratingDevelopmentChargesPreList = action.payload;
    },
    setDevelopmentCharges: (state, action) => {
      state.DevelopmentCharges = action.payload;
    },
    setSelectedDevelopmentCharges: (state, action) => {
      const selectedDevelopmentCharges: DevelopmentChargesModel[] = action.payload;
      state.DevelopmentCharges?.map((developmentCharge) => {
        selectedDevelopmentCharges.findIndex((selected) => {
          return selected.preListID == developmentCharge.preListID;
        }) > -1
          ? (developmentCharge.selectedForClientCharges = true)
          : (developmentCharge.selectedForClientCharges = false);
        return developmentCharge;
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(calculateDevelopmentChargesPreListBackgroundProcess.pending, (state) => {
      state.GeneratingDevelopmentChargesPreList = true;
      state.RunDevelopmentChargesCalculation = false;
      state.DevelopmentCharges = [];
    });
  },
});

export const calculateDevelopmentChargesPreListBackgroundProcess = createAsyncThunk<
  void,
  undefined,
  { state: RootState }
>("developmentChargesPreList/calculateDevelopmentChargesPreListBackgroundProcess", async (_, thunkAPI) => {
  const serviceChargeInvoicingService = container.get<IServiceChargeInvoicingService>(
    SERVICE_TYPES.ServiceChargeInvoicingService
  );
  const state = thunkAPI.getState();
  await serviceChargeInvoicingService.calculateDevelopmentChargesPreListBackgroundProcess(
    state.serviceChargeInvoicing.ServiceChargeInvoice
  );
});

export const {
  setGeneratingDevelopmentChargesPreList,
  setDevelopmentCharges,
  setSelectedDevelopmentCharges,
  setRunPreListCalculation,
} = DevelopmentChargesPreListSlice.actions;

export const selectRunDevelopmentChargesCalculation = (state: RootState) =>
  state.serviceChargeDevelopmentChargePreList.RunDevelopmentChargesCalculation;
export const selectGeneratingDevelopmentChargesPreList = (state: RootState) =>
  state.serviceChargeDevelopmentChargePreList.GeneratingDevelopmentChargesPreList;
export const selectDevelopmentCharges = (state: RootState) =>
  state.serviceChargeDevelopmentChargePreList.DevelopmentCharges;
export const selectSelectedDevelopmentCharges = (state: RootState) =>
  state.serviceChargeDevelopmentChargePreList.DevelopmentCharges?.filter(
    (developmentCharge) => developmentCharge.selectedForClientCharges
  );

export default DevelopmentChargesPreListSlice.reducer;
